import type { LucideIcon } from "lucide-react";
import { Line, LineChart, ResponsiveContainer } from "recharts";

type MetricCardProps = {
  label: string;
  value: string;
  color: string;
  icon: LucideIcon;
  series?: number[];
  muted?: boolean;
};

export function MetricCard({ label, value, color, icon: Icon, series, muted }: MetricCardProps) {
  const data = (series ?? []).map((point, index) => ({ index, point }));

  return (
    <article className={`metric-card ${muted ? "metric-card--muted" : ""}`}>
      <div className="metric-card__header">
        <span>{label}</span>
        <i style={{ color }}>
          <Icon size={18} strokeWidth={2.1} />
        </i>
      </div>
      <strong>{value}</strong>
      {data.length > 1 && (
        <div className="sparkline" aria-hidden="true">
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={data}>
              <Line
                type="monotone"
                dataKey="point"
                stroke={color}
                strokeWidth={1.8}
                dot={false}
                isAnimationActive={false}
              />
            </LineChart>
          </ResponsiveContainer>
        </div>
      )}
    </article>
  );
}
